import MainLayout from 'layouts/MainLayout';
import { RouteObject, createBrowserRouter, useParams } from 'react-router-dom';
import MainLayoutProvider from 'providers/MainLayoutProvider';
import Error404 from 'pages/error/Error404';
import Error403 from 'pages/error/Error403';
import Error500 from 'pages/error/Error500';
import App from 'App';
import CardSignIn from 'pages/authentication/SignIn';
import SAMLCallback from 'pages/authentication/SAMLCallback';
import CardForgotPassword from 'pages/authentication/ForgotPassword';
import CardSignOut from 'pages/authentication/SignOut';
import CardResetPassword from 'pages/authentication/ResetPassword';
import CardNoRoles from 'pages/authentication/NoRolesScreen';
import UserProfile from 'pages/systemmanagement/GetUserProfile';
import UserDashboard from 'pages/systemmanagement/UserManagementDashboard';
import SystemLog from 'pages/systemmanagement/SystemLog';
import RegisterUser from 'pages/systemmanagement/CreateNewUser';
import CampaignAssigment from 'pages/servicecampaignmanagement/CampaignAssigment';
import ServiceManagement from 'pages/servicecampaignmanagement/ServiceManagement';
import CampaignManagement from 'pages/servicecampaignmanagement/CampaignManagement';
import ActualCalling from 'pages/hvamanagement/ActualCalling';
import CampaignToday from 'pages/hvamanagement/CampaignToday';
import CampaignStartStop from 'pages/hvamanagement/CampaignStartStop';
import CampaignRecordingExplorer from 'pages/hvamanagement/CampaignRecordingExplorer';
import CampaignCustomerList from 'pages/hvamanagement/CampaignCustomerList';
import CampaignCallListUploading from 'pages/hvamanagement/CampaignCallListUploading';
import CallAnalysis from 'pages/hvaqualityassurance/CallAnalysis';
import QADashboard from 'pages/hvaqualityassurance/QADashboard';
import QAProcessorLog from 'pages/hvaqualityassurance/QAProcessorLog';
import ScorecardManagement from 'pages/hvaqualityassurance/ScorecardManagement';
import RiskDashboard from 'pages/hvaqualityassurance/RiskDashboard';
import RiskReviewDashboard from 'pages/hvaqualityassurance/RiskReviewDashboard';
import RiskManagement from 'pages/hvaqualityassurance/RiskManagement';
import ScorecardAndRiskAssignment from 'pages/hvaqualityassurance/ScorecardAndRiskAssignment';
import CampaignPerformance from 'pages/hvareporting/CampaignPerformance';
import CallResultsReport from 'pages/hvareporting/CallResultsReport';
import KnowledgeHubDashboard from 'pages/knowledgehub/KnowledgeHubDashboard';
import YourHVAs from 'pages/hva/yourhvas';
import HVAPOCubimia from 'pages/hva/POCpfstech/HVAPOCPFS';
import HVAPOCGreece from 'pages/hva/POCGreece/HVAPOCGreece';
import HVAPOCServinform from 'pages/hva/POCServinform/HVAPOCServinform';
import HVAPOCKeldai from 'pages/hva/POCKeldai/HVAPOCKeldai';
import HVAServGlobalCaja from 'pages/hva/hvaServGlobalCaja';
import HVAAgentFineTuningPage from 'pages/hva/conversationalEngine/HVAAgentFineTuningPage';
import AureaHVAAgent from 'pages/hva/conversationalEngine/AureaHVAAgent';
import HVAAgentManagement from 'pages/hva/conversationalEngine/HVAAgentManagement';
import AIModelsManagement from 'pages/hva/aimodels/AIModelsManagement';
import ComingSoon from 'pages/ComingSoon';

import Faq from 'pages/faq/Faq';

const CampaignTodayWrapper = () => {
  const { id, bxpid, campaigntype, title, brand } = useParams<{
    id: string;
    bxpid: string;
    campaigntype: string;
    title: string;
    brand: string;
  }>();

  // Validar que campaignType sea válido
  const validCampaignType =
    campaigntype === 'inbound' || campaigntype === 'outbound'
      ? campaigntype
      : 'outbound'; // valor por defecto

  return (
    <CampaignToday
      campaignId={Number(id)}
      campaignbxpId={Number(bxpid)}
      campaignType={validCampaignType}
      title={title || 'Default Title'} // Valor por defecto para title
      brand={brand || 'defaultBrand'} // Valor por defecto para brand
    />
  );
};

const routes: RouteObject[] = [
  {
    element: <App />,
    children: [
      {
        path: '/',
        element: (
          <MainLayoutProvider>
            <MainLayout />
          </MainLayoutProvider>
        ),
        children: [
          {
            index: true,
            element: <ActualCalling />
          },
          {
            path: '/hvasystem',
            children: [
              {
                path: 'startstop',
                element: <CampaignStartStop />
              },
              {
                path: 'recordingexplorer',
                element: <CampaignRecordingExplorer />
              },
              {
                path: 'customerlist',
                element: <CampaignCustomerList />
              },
              {
                path: 'calllistuploading',
                element: <CampaignCallListUploading />
              },
              {
                path: 'comingsoon',
                element: <ComingSoon />
              }
            ]
          },
          {
            path: '/hvareporting',
            children: [
              {
                path: 'callresultsreport',
                element: <CallResultsReport />
              }
            ]
          },
          {
            path: '/hvareporting',
            children: [
              {
                path: 'campaignperformance',
                element: <CampaignPerformance />
              }
            ]
          },
          {
            path: '/hvaqualityassurance',
            children: [
              {
                path: 'qadashboard',
                element: <QADashboard />
              },
              {
                path: 'callanalysis',
                element: <CallAnalysis />
              },
              {
                path: 'qaprocessorlog',
                element: <QAProcessorLog />
              },
              {
                path: 'scorecardmanagement',
                element: <ScorecardManagement />
              },
              {
                path: 'riskmanagement',
                element: <RiskManagement />
              },
              {
                path: 'riskdashboard',
                element: <RiskDashboard />
              },
              {
                path: 'riskreview',
                element: <RiskReviewDashboard />
              },
              {
                path: 'scorecardassignment',
                element: <ScorecardAndRiskAssignment />
              }
            ]
          },
          {
            path: '/knowledgehub',
            element: <KnowledgeHubDashboard />
          },
          {
            path: '/actualcalling',
            children: [
              {
                path: 'campaign/:id/:bxpid/:campaigntype/:title/:brand',
                element: <CampaignTodayWrapper />
              }
            ]
          },
          {
            path: '/user-management',
            children: [
              {
                path: 'user-profile',
                element: <UserProfile />
              },
              {
                path: 'register-user',
                element: <RegisterUser />
              }
            ]
          },
          {
            path: '/system-management',
            children: [
              {
                path: 'system-dashboard',
                element: <UserDashboard />
              },
              {
                path: 'system-log',
                element: <SystemLog />
              }
            ]
          },
          {
            path: '/campaign',
            children: [
              {
                path: 'service-management',
                element: <ServiceManagement />
              },
              {
                path: 'campaign-management',
                element: <CampaignManagement />
              },
              {
                path: 'access-management',
                element: <CampaignAssigment />
              }
            ]
          },
          {
            path: '/system',
            children: [
              {
                path: 'faq',
                element: <Faq />
              },
              {
                path: 'hvas',
                element: <YourHVAs />
              },
              {
                path: 'hvaservGlobalcaja',
                element: <HVAServGlobalCaja />
              },
              {
                path: 'hvapocservinform',
                element: <HVAPOCServinform />
              },
              {
                path: 'hvapocexamplescenarios',
                element: <HVAPOCKeldai />
              },
              {
                path: 'hvapocubimia',
                element: <HVAPOCubimia />
              },
              {
                path: 'poc',
                children: [
                  {
                    path: 'greece',
                    element: <HVAPOCGreece />
                  }
                ]
              },
              {
                path: 'conversationalengine',
                children: [
                  {
                    path: 'agentfinetuning',
                    element: <HVAAgentFineTuningPage />
                  },
                  {
                    path: 'agentmanagement',
                    element: <HVAAgentManagement />
                  },
                  {
                    path: 'aimodelsmanagement',
                    element: <AIModelsManagement />
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: '/errors/',
        children: [
          {
            path: '404',
            element: <Error404 />
          },
          {
            path: '403',
            element: <Error403 />
          },
          {
            path: '500',
            element: <Error500 />
          }
        ]
      },
      {
        path: '/authentication/',
        children: [
          {
            path: 'sign-in',
            element: <CardSignIn />
          },
          {
            path: 'sign-out',
            element: <CardSignOut />
          },
          {
            path: 'forgot-password',
            element: <CardForgotPassword />
          },
          {
            path: 'reset-password',
            element: <CardResetPassword />
          },
          {
            path: 'pending-roles',
            element: <CardNoRoles />
          },
          {
            path: 'callback',
            element: <SAMLCallback />
          },
          {
            path: 'virtualagent',
            element: <AureaHVAAgent />
          }
        ]
      },
      {
        path: '*',
        element: <Error404 />
      }
    ]
  }
];

export const router = createBrowserRouter(routes);

export default routes;
